import { AuthActionsUnion, AuthActionTypes, UpdateBearerToken } from './auth.actions';
import { IUser } from '../../user-info/IUser';
import { LoginRequestStatus } from '../../efaact-configuration/efaact-configuration.module';
import { ISignInDialogData } from '../ISignInDialogData';
import { IAuthenticateSecurityQuestion } from '../authentication.service';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IRememberMe } from '../IRememberMe';

// this state is stand alone, since it is ONLY for authentication/authorization.
// no other part of the app needs to know about it, authentication is handled within
// an http handler that adds auth token to each request.

export interface State
    extends ISignInDialogData,
        IAuthenticateSecurityQuestion,
        IRememberMe {
    token: string;
    loggedIn: boolean;
    CustomerID?: string;
}

export const initialState: State = {
    username: null,
    password: null,
    pin: null,
    accessCode: null,
    securityAnswer: null,
    securityQuestion: null,
    accessCodeDeliveryType: null,
    accessCodeRequestMethods: null,
    status: LoginRequestStatus.SubmitUsernamePasswordAndPIN,
    message: null,
    cancel: false,
    token: null,
    loggedIn: false,
    rememberMe: false,
    CustomerID: null
};

export function reducer(state = initialState, action: AuthActionsUnion): State {
    switch (action.type) {
        case AuthActionTypes.LoginFailure: {
            return {
                // ...initialState,
                ...state, // don't want to erase username/password/pin,
                password:
                    action.payload.StatusCode ===
                    LoginRequestStatus.InvalidUsernameOrPassword
                        ? null
                        : state.password,
                message: action.payload.ErrorMessage
            };
        }
        case AuthActionTypes.LoginSuccess: {
            return {
                ...state,
                loggedIn: true,
                token: action.payload.BearerToken,
                password: null,
                status: LoginRequestStatus.LoginSuccessful,
                message: null,
                CustomerID: action.payload.CustomerID
            };
        }
        case AuthActionTypes.LoginSelectAccessCode: {
            return {
                ...state,
                status: LoginRequestStatus.SelectAccessCodeMethod,
                accessCodeRequestMethods:
                    action.payload.AccessCodeRequestMethods,
                message: null
            };
        }
        case AuthActionTypes.LoginAnswerSecurityQuestion: {
            return {
                ...state,
                status: LoginRequestStatus.AnswerSecurityQuestion,
                securityQuestion: action.payload.SecurityQuestion,
                message: null
            };
        }
        case AuthActionTypes.LoginAccessCodeSent: {
            return {
                ...state,
                status: LoginRequestStatus.AccessCodeSent,
                message: null
            };
        }
        case AuthActionTypes.Logout: {
            return {
                ...initialState,
                username: state.rememberMe ? state.username : null,
                pin: state.rememberMe ? state.pin : null,
                rememberMe: state.rememberMe
            };
        }
        case AuthActionTypes.SendUsernamePasswordPin: {
            return {
                ...state,
                username: action.payload.username,
                password: action.payload.password,
                pin: action.payload.pin,
                message: null
            };
        }
        case AuthActionTypes.SendAccessCodeMethod: {
            return {
                ...state,
                accessCodeDeliveryType: action.payload.accessCodeDeliveryType,
                message: null
            };
        }
        case AuthActionTypes.SendAccessCode: {
            return {
                ...state,
                accessCode: action.payload.accessCode,
                message: null
            };
        }
        case AuthActionTypes.SendSecurityAnswer: {
            return {
                ...state,
                securityAnswer: action.payload.securityAnswer,
                message: null
            };
        }
        case AuthActionTypes.RememberMe:
            return {
                ...state,
                rememberMe: action.payload.rememberMe,
                username: action.payload.username,
                pin: action.payload.pin
            };
        case AuthActionTypes.UpdateBearerToken: {
            return {
                ...state,
                token: action.payload.token
            };
        }
        default: {
            return state;
        }
    }
}
const selectAuthState = createFeatureSelector<State>('auth');
export const getLoggedIn = createSelector(selectAuthState, x => x.loggedIn);
export const getAuthToken = createSelector(selectAuthState, x => x.token);
export const getAuth = createSelector(selectAuthState, x => x);
